import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import gridLabels from "../Labels/GridLabels";
import CHAPTERS_COLUMNS from "./ChaptersTableColumn";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import RowButtonIcon from "../UI/RowButtonIcon";
import EditIcon from "@mui/icons-material/Edit";
import ButtonAdd from "../UI/ButtonAdd";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import DialogDelete from "../UI/DialogDelete";
import SearchInput from "../UI/SearchInput";
import { DeleteOutline } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import RowButtonLabel from "../UI/RowButtonLabel";
import StartingPageContent from "../StartingPage/StartingPageContent";
import useChapterStore from "../../store/zustandStore/chapterZs";
import ChapterModalEditor from "./ChapterModalEditor";
import { Button } from "@mui/material";
import { saveAs } from "file-saver";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  NumberFormat,
  Footer,
  AlignmentType,
  PageNumber,
  UnderlineType,
} from "docx";
import ImagePrint from "./PrintWord/ImagePrint";
import { TableSwitchPrint } from "./TableWordUtils/TableSwitchPrint";
import useGlobalStore from "../../store/zustandStore/globalStoreZs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getYearReport, setYearReport } from "./Utils/useYearRaport";
import ParagraphPrint from "./PrintWord/ParagraphPrint";

const ChaptersTable = () => {
  const navigate = useNavigate();
  const { setMessageEmptyZs, setLoadingZs } = useGlobalStore();
  const onBackNavigation = () => {
    navigate(-1);
  };
  const location = useLocation();

  const { reportId, reportTitle, year } = location.state;
  const { totalPages, size, currentPage, searchValueCurrent } = useSelector(
    (state) => state.njesiRaportuese
  );

  if (year !== undefined && year !== null) {
    setYearReport(year);
  }
  const yearReport = getYearReport();

  const { chaptersZs, fetchChaptersZs, deleteChapterZs } = useChapterStore();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [chapter, setChapter] = React.useState({});
  const [dataColumns, setDataColumns] = React.useState(CHAPTERS_COLUMNS);
  const [page, setPage] = React.useState(currentPage);
  const searchState = React.useRef("");
  const [searchValueServer, setSearchValueServer] =
    React.useState(searchValueCurrent);

  const initialChapter = {
    id: "",
    title: "",
    reportId: reportId,
  };

  const handleChangePage = (event, newPage) => {
    setPage(event);
  };

  const searchItems = (e) => {
    const searchValue = e.target.value;
    if (searchValue !== "") {
      searchState.current.value = searchValue;
      let filterTimeout;
      filterTimeout = setTimeout(() => {
        setSearchValueServer(searchState.current.value);
      }, 1000);
    } else {
      setSearchValueServer("");
      //   dispatch(getAllUnit({ page: page, searchValue: "" }));
    }
  };

  React.useEffect(() => {
    fetchChaptersZs(reportId);
  }, [reportId]);

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setChapter(e.row);
    setOpen(true);
  };

  const addNew = () => {
    setIsStatusNew(true);
    setChapter(initialChapter);
    setOpen(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleDeleteChapter = (e) => {
    deleteChapterZs(chapter);
    setStateDialogDelete(false);
  };

  const openChapterEditorSelected = (e) => {
    navigate("/reports-print/chapter-editor", {
      state: { reportId: reportId, chapter: e.row, year: year },
    });
  };

  // Export to Word
  const exportToWordFinal = async () => {
    setLoadingZs(true);
    const docChildren = [];

    const sortedChapters = chaptersZs.slice().sort((a, b) => a.order - b.order);

    for (const chapter of sortedChapters) {
      if (chapter?.content !== null) {
        for (const item of chapter?.content) {
          if (item.type === "paragraph") {
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
            // docChildren.push(
            //   new Paragraph({
            //     style: "arial",
            //     children: [new TextRun(item.text)],
            //   })
            // );
            docChildren.push(await ParagraphPrint(item));
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
          } else if (item.type === "table") {
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
            docChildren.push(...(await TableSwitchPrint(item))); // HERE ADD Table
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
          } else if (item.type === "image" && item.imageURL) {
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
            docChildren.push(await ImagePrint(item));
            docChildren.push(new Paragraph({ children: [new TextRun("")] }));
          }
        }
      }
    }
    const doc = new Document({
      styles: {
        default: {
          document: {
            run: {
              font: "Arial", // Set Arial as the default font
              size: 24, // 12pt
            },
          },
        },

        paragraphStyles: [
          {
            id: "wellSpaced",
            name: "Well Spaced",
            basedOn: "Normal",
            run: {
              size: 28,
              bold: true,
              color: "FF0000",
            },
            quickFormat: true,
            paragraph: {
              spacing: {
                line: 276,
                before: 20 * 72 * 0.1,
                after: 20 * 72 * 0.05,
              },
            },
          },
          {
            id: "arial",
            name: "Arial",
            font: "Arial",
            basedOn: "Normal",
            run: {
              size: "12pt",
            },
            quickFormat: true,
            paragraph: {
              spacing: {
                line: 276,
                before: 20 * 72 * 0.1,
                after: 20 * 72 * 0.05,
              },
            },
          },
          {
            id: "strikeUnderline",
            name: "Strike Underline",
            basedOn: "Normal",
            quickFormat: true,
            run: {
              strike: true,
              underline: {
                type: UnderlineType.SINGLE,
              },
            },
          },
        ],
      },
      sections: [
        {
          properties: {
            page: {
              pageNumbers: {
                start: 1,
                formatType: NumberFormat.DECIMAL,
              },
            },
          },
          footers: {
            default: new Footer({
              children: [
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      children: ["AMA"],
                    }),
                  ],
                }),
                new Paragraph({
                  style: "wellSpaced",
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      children: [PageNumber.CURRENT],
                    }),
                  ],
                }),
              ],
            }),
          },
          children: docChildren,
        },
      ],
    });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, reportTitle + "_" + yearReport + ".docx");
    setLoadingZs(false);
  };

  function CustomToolbar() {
    return (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            py: "18px",
            px: "9px",
            alignItems: "center",
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              direction: "column",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <SearchInput
              onChange={searchItems}
              inputRef={searchState}
              defaultValue={searchState.current.value}
            ></SearchInput> */}
          </Box>
          <Button
            startIcon={<FileDownloadIcon />}
            sx={{
              "&.MuiButtonBase-root.MuiButton-root": {
                background: "#2b64ef",
                ":hover": { background: "#14203e" },
                fontSize: "14px",
                minWidth: "150px",
                width: "140px",
                height: "48px",
                color: "#fff",
                borderRadius: "8px",
                marginLeft: "5px",
              },
            }}
            onClick={exportToWordFinal}
          >
            Raport Vjetor
          </Button>
          <ButtonAdd onClick={addNew} />
        </Box>
      </Box>
    );
  }
  return (
    <StartingPageContent
      pageName={`Kapitull - ${reportTitle}`}
      description={"Viti - " + year}
      back
      onClick={onBackNavigation}
    >
      <div style={{ height: 700, width: "100%" }}>
        <DataGrid
          labelRowsPerPage="Artikuj per faqe"
          disableSelectionOnClick
          onRowDoubleClick={openChapterEditorSelected}
          sortModel={[
            {
              field: "order", // Fushe për renditje
              sort: "asc", // Renditje në rritje (për përdorim "desc" për renditje në zbritje)
            },
          ]}
          columns={[
            ...dataColumns,
            {
              headerName: "",
              overflow: "hidden",
              field: "action",
              editable: false,
              flex: 1,
              justifyContent: "flex-end",
              disableClickEventBubbling: true,
              align: "right",
              background: "red",
              headers: false,
              renderHeader: () => {},
              renderCell: (params) => (
                <BoxRowButtonsIcon>
                  <RowButtonLabel
                    onClick={(event) => {
                      openChapterEditorSelected(params);
                    }}
                    startIcon={<FolderOpenIcon />}
                  >
                    Modifiko
                  </RowButtonLabel>
                  <RowButtonIcon
                    onClick={(event) => {
                      currentlySelected({ reportId: reportId, ...params });
                    }}
                  >
                    <EditIcon />
                  </RowButtonIcon>
                  <RowButtonIcon
                    onClick={(event) => {
                      setChapter({ reportId: reportId, ...params?.row });
                      setStateDialogDelete(true);
                    }}
                  >
                    <DeleteOutline color="error" />
                  </RowButtonIcon>
                </BoxRowButtonsIcon>
              ),
            },
          ]}
          // rows={njesiRaportuese ? njesiRaportuese : []}
          rows={chaptersZs ? chaptersZs : chaptersZs}
          density="comfortable"
          editMode="row"
          disableColumnMenu
          localeText={gridLabels}
          componentsProps={{
            pagination: {
              labelRowsPerPage: "Rreshta për Faqe",
              showLastButton: true,
              showFirstButton: true,
            },
          }}
          components={{
            Toolbar: CustomToolbar,
          }}
          // onCellClick={currentlySelected}
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel) =>
            setFilterModel(newFilterModel)
          }
          page={page}
          onPageChange={handleChangePage}
          // count={totalPages}
          count={totalPages}
          // rowCount={totalElements}
          rowCount={1}
          pageSize={size > 100 ? 100 : size}
          pagination
          paginationMode="server"
        />
        <DialogDelete
          open={stateDialogDelete}
          disagreedelete={handleCloseDialogDelete}
          agreedelete={handleDeleteChapter}
          description="Jeni të sigurt që doni ta fshini këtë Kapitull? "
        />
        <ChapterModalEditor
          chapterLength={chaptersZs.length}
          open={open}
          reportId={reportId}
          onClose={handleClose}
          formname="Kapitull"
          isstatusnew={isStatusNew ? 1 : 0}
          data={chapter}
        ></ChapterModalEditor>
      </div>
    </StartingPageContent>
  );
};

export default ChaptersTable;
